import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12.01 12V7.242a.75.75 0 011.126-.65l8.239 4.757a.75.75 0 010 1.3l-8.24 4.757a.75.75 0 01-1.125-.65v-1.828"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M11.644 11.365a.732.732 0 010 1.268l-8.268 4.773a.75.75 0 01-1.126-.65v-1.76"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M2.25 15.172v-7.93a.751.751 0 011.126-.65l6.632 3.83"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12.01 12V7.242a.75.75 0 011.126-.65l8.239 4.757a.75.75 0 010 1.3l-8.24 4.757a.75.75 0 01-1.125-.65v-1.828"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M11.644 11.365a.732.732 0 010 1.268l-8.268 4.773a.75.75 0 01-1.126-.65v-1.76"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M2.25 15.172v-7.93a.751.751 0 011.126-.65l6.632 3.83"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M24.02 24v-9.516c0-1.156 1.25-1.876 2.252-1.3l16.478 9.514c1 .578 1 2.022 0 2.6l-16.478 9.514a1.5 1.5 0 01-2.252-1.3v-3.656"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M23.287 22.73a1.464 1.464 0 010 2.537L6.751 34.813a1.501 1.501 0 01-2.252-1.3v-3.52"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M4.5 30.344v-15.86c0-1.156 1.252-1.876 2.252-1.3l13.264 7.658"
  }))
};
export var FastForward = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});